import React from 'react';
import { withRouter } from 'react-router-dom';
import styles from './emailConfirmationAlert.scss';

const EmailConfirmationAlert = props => {
    const { errorAlertMessage, successAlertMessage, confirmEmailEvent, showSecondaryAlert, secondaryAlertMessage, toggleSecondaryAlert, closeSecondaryAlert } = props;

    const clickEmailHandler = alert => {
        if (alert === 'initialAlert') {
            return confirmEmailEvent();
        }
        if (alert === 'closeAlert') {
            return closeSecondaryAlert();
        }
        if (alert === 'errorAlert') {
            return confirmEmailEvent();
        }
        if (alert === 'successAlert') {
            return props.history.push('/home');
        }
        return null;
    };

    const emailAlert = {
        initialAlert:
    <div onClick={() => clickEmailHandler('initialAlert')} className={`alert alert-primary ${styles.confirmation}`} data-testid="email-confirmation-alert.initial">
        <div>
            Click <strong>here</strong> to confirm your email account
        </div>
    </div>,
        successAlert:
    <div onClick={() => clickEmailHandler('successAlert')} className={`alert alert-primary ${styles.confirmation}`} data-testid="email-confirmation-alert.success"><div>{successAlertMessage}</div></div>,

        errorAlert:
    <div onClick={() => clickEmailHandler('errorAlert')} className={`alert alert-primary ${styles.confirmation}`} data-testid="email-confirmation-alert.error">{errorAlertMessage}</div>,

        secondaryAlert:
    <div className={`alert alert-primary alert-dismissible fade show ${styles.confirmation} ${styles.successAlert}`} role="alert" data-testid="email-confirmation-alert.secondary">
        <strong data-testid="email-confirmation-alert.secondary.message">{secondaryAlertMessage}</strong>

        <button onClick={() => clickEmailHandler('closeAlert')} type="button" className="close" data-dismiss="alert" aria-label="Close" data-testid="email-confirmation-alert.secondary.close-btn">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>,
    };

    if (showSecondaryAlert && toggleSecondaryAlert) {
        return emailAlert.secondaryAlert;
    }

    if (successAlertMessage) {
        return emailAlert.successAlert;
    }

    if (!showSecondaryAlert && errorAlertMessage) {
        return emailAlert.errorAlert;
    }

    if (!showSecondaryAlert) {
        return emailAlert.initialAlert;
    }
    return null;
};
export default withRouter(EmailConfirmationAlert);
